<template>
    <dashlet-card :page-tooltip="t_page_tooltip_mediapool"
                  :title="t_title"
                  page-href="/content/mediapool">
        <template #append>
            <disk-usage-meter :file-count="totalCount"
                              :quota="quota"
                              :usage="usage"
                              style="flex-grow: 1;"/>
        </template>
        <template #prependButton>
            <square-button :disabled="loading"
                           :loading="loading"
                           :tooltip-text="t_refresh_tooltip"
                           flat
                           icon="far fa-arrows-rotate"
                           @click="fetchMedia" />
        </template>

        <div v-if="error"
             class="ibox-content">
            <div class="load-media-notifications">
                <div class="alert alert-danger"
                     style="margin-bottom: 0;">
                    {{ t_error_not_loaded }}
                </div>
            </div>
        </div>

        <loading-placeholder v-if="loading && !anyFiles" />

        <list v-else-if="anyFiles"
              :files="files"
              :loading="loading"
              :readonly="true"
              :small="true"
              element-class="four-in-a-row"
              force-mode="tiles" />

        <div v-else
             class="dashlet-message-container">
            {{ noFilesMessage }}
        </div>
        <show-media-modal />
    </dashlet-card>
</template>

<script>
import Template from '../../content/elements/template'
import Filecounter from '../../content/mediapool/filecounter.vue'
import List from '../../content/mediapool/mediapoolList.vue'
import Search from '../../content/mediapool/search.vue'
import ShowMediaModal from '../../content/mediapool/show-media-modal.vue'
import DashletCard from './dashlet-card.vue'
import SquareButton from '../../content/common/squareButton.vue'
import LoadingPlaceholder from '../../content/common/loadingPlaceholder.vue'
import DiskUsageMeter from '../../content/mediapool/disk-usage-meter.vue'

export default {
    props: {
        showCount: Number
    },
    components: {
        DiskUsageMeter,
        LoadingPlaceholder,
        SquareButton,
        DashletCard,
        Template,
        Filecounter,
        List,
        Search,
        ShowMediaModal
    },
    data() {
        return {
            loading: true,
            error: false,

            files: [],
            totalCount: 0,

            quota: undefined,
            usage: undefined,

            t_title: Lang.langGet('Mediapool'),
            t_page_tooltip_mediapool: Lang.langGet('Mediapool'),
            t_refresh_tooltip: Lang.langGet('Reload'),

            t_error_not_loaded: Lang.langGet('Failed to load media files!')
        }
    },
    methods: {
        fetchMedia() {
            this.loading = true
            this.error = false

            this.quota = undefined
            this.usage = undefined

            Promise.all([
                axios.post('/dashboard/mediapool/get', {
                    id: Laravel.activeProject,
                    count: this.showCount
                }).then((response) => {
                    response.data.data.forEach((dataEntry => {

                        // 'created_at' and 'updated_at' are localised AND in UTC
                        dataEntry.created_at_millis = EaseEventBus._validityDateUTCToJsDate(dataEntry.created_at).getTime()
                        dataEntry.created_at_local = EaseEventBus._FormatDateTimeEntryToLocaleString(dataEntry.created_at_millis)
                        dataEntry.updated_at_millis = EaseEventBus._validityDateUTCToJsDate(dataEntry.updated_at).getTime()
                        dataEntry.updated_at_local = EaseEventBus._FormatDateTimeEntryToLocaleString(dataEntry.updated_at_millis)

                    }));
                    this.files = response.data.data
                    this.totalCount = response.data.totalCount
                }).catch((error) => {
                    this.files = []
                    this.totalCount = 0
                    this.error = error
                    if (error.response.status === 401) {
                        window.location = '/login'
                    }
                }),
                axios.get('/dashboard/storage/get').then((response) => {
                    this.quota = response.data.quota
                    this.usage = response.data.usage
                }).catch((error) => {
                    if (error.response.status === 401) {
                        window.location = '/login'
                    }
                })

            ]).finally(() => {
                this.loading = false
            })
        }
    },
    computed: {
        anyFiles() {
            return this.files?.length > 0
        },
        noFilesMessage() {
            return `0 ${Lang.langChoice('File|Files', 0)}`
        }
    },
    created() {
        this.fetchMedia()
    }
}
</script>
